import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { CircularProgress } from '@mui/material';

const Card_Nominee_Int = () => {
    const [srcno, setSrcno] = useState('');
    const [details, setDetails] = useState(null);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [vroName, setVroName] = useState('');
    const [vroUid, setVroUid] = useState('');
    const [vroMobile, setVroMobile] = useState('');
    const [nomStatus, setNomStatus] = useState('');
    const [fpsId, setFpsId] = useState('');
    const [srcNo, setSrcNo] = useState('');
    const [uidError, setUidError] = useState('');
    const [confirmation, setConfirmation] = useState(null);

    useEffect(() => {
        const style = document.createElement('style');
        style.innerHTML = `
            #rc_no_input:-webkit-autofill,
            #rc_no_input:-webkit-autofill:hover,
            #rc_no_input:-webkit-autofill:focus,
            #rc_no_input:hover,
            #rc_no_input:focus {
                background-color: white !important;
                box-shadow: 0 0 0px 1000px white inset !important;
                -webkit-box-shadow: 0 0 0px 1000px white inset !important;
                caret-color: black !important;
            }
            .styleVRO {
                color: #990000;
                font-weight: bold;
                font-size: 20px;
            }
            .tableheader {
                background-color: #f0f0f0; 
            }
            .button.button2 {
            }
        `;
        document.head.appendChild(style);
        return () => {
            document.head.removeChild(style);
        };
    }, []);

    const fetchDetails = async (srcno) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_URL}/api/nominee/details?srcno=${srcno}`);
            return response.data;
        } catch (error) {
            console.error(error);
            let errorMessage = 'An error occurred while fetching details. Please try again.';
            if (error.response && error.response.status === 500) {
                errorMessage = 'Internal Exception';
            }
            return { type: 'error', vro_message: errorMessage };
        }
    };

    const detailsF = async () => {
        if (srcno === null || srcno === '' || srcno === undefined) {
            alert('Please Fill SRC No');
            return null;
        }
        setLoading(true);
        setMessage('');
        setUidError('');
        setConfirmation(null);
        const data = await fetchDetails(srcno);
        setDetails(data);
        if (data.type === 'update') {
            setVroName(data.vro_name || '');
            setVroUid(data.vro_uid || '');
            setVroMobile(data.remarks || '');
            setSrcNo(data.srcno);
            setFpsId(data.fps_id);
        } else if (data.type === 'add') {
            setSrcNo(data.srcno);
            setFpsId(data.fps_id);
            setNomStatus(data.nom_status);
            setVroName('');
            setVroUid('');
            setVroMobile('');
        } else if (data.type === 'view') {
            setVroName(data.vro_name || '');
            setFpsId(data.fps_id || '');
            setVroMobile(data.remarks || '');
        }
        setLoading(false);
        return data;
    };

    const cardsAdd = async () => {
        const namelen = vroName.length;
        if (namelen < 4) {
            alert('Invalid Name');
            return false;
        }
        if (vroName === 'xxx' || vroName === 'XXXX' || vroName === 'yyy' || vroName === 'YYY' || vroName === 'zzz' || vroName === 'zzz') {
            alert('Please Enter Valid Name');
            return false;
        }
        const lenn = vroUid.length;
        if (lenn < 12 || lenn > 12) {
            alert('Invalid UID');
            return false;
        }
        const mobile_lenn = vroMobile.length;
        if (mobile_lenn < 10 || mobile_lenn > 10) {
            alert('Invalid Mobile');
            return false;
        }
        if (vroMobile === '0000000000' || vroMobile === '1111111111' || vroMobile === '2222222222' || vroMobile === '3333333333' || vroMobile === '4444444444' || vroMobile === '5555555555' || vroMobile === '6666666666' || vroMobile === '7777777777' || vroMobile === '8888888888' || vroMobile === '9999999999') {
            alert('Please Enter Valid Phone No');
            return false;
        }
        if ((vroMobile.substring(0, 1) !== '9') && (vroMobile.substring(0, 1) !== '8') && (vroMobile.substring(0, 1) !== '7') && (vroMobile.substring(0, 1) !== '6')) {
            alert('Invalid Phone No ');
            return false;
        }
        setMessage('');
        try {
            const dto = { src_no: srcNo, fps_id: fpsId, vro_name: vroName, vro_uid: vroUid, vro_mobile: vroMobile, nom_status: nomStatus };
            const response = await axios.post(`${process.env.REACT_APP_URL}/api/nominee/add`, dto, {
                headers: {
                    'X-React-Route': window.location.href
                }
            });
            const newDetails = await fetchDetails(srcNo);
            newDetails.check2 = details.check2;
            setConfirmation({
                message: response.data,
                details: newDetails
            });
            setDetails(null);
            setMessage('');
        } catch (error) {
            console.error(error);
            if (error.response && error.response.status === 500) {
                setMessage('Internal Exception');
            } else {
                setMessage('An error occurred while adding the nominee. Please try again.');
            }
        }
    };

    const cardsUpdate = async () => {
        const namelen = vroName.length;
        if (namelen < 4) {
            alert('Invalid Name');
            return false;
        }
        if (vroName === 'xxx' || vroName === 'XXXX' || vroName === 'yyy' || vroName === 'YYY' || vroName === 'zzz' || vroName === 'zzz') {
            alert('Please Enter Valid Name');
            return false;
        }
        const lenn = vroUid.length;
        if (lenn < 12 || lenn > 12) {
            alert('Invalid UID');
            return false;
        }
        const mobile_lenn = vroMobile.length;
        if (mobile_lenn < 10 || mobile_lenn > 10) {
            alert('Invalid Mobile');
            return false;
        }
        if (vroMobile === '0000000000' || vroMobile === '1111111111' || vroMobile === '2222222222' || vroMobile === '3333333333' || vroMobile === '4444444444' || vroMobile === '5555555555' || vroMobile === '6666666666' || vroMobile === '7777777777' || vroMobile === '8888888888' || vroMobile === '9999999999') {
            alert('Please Enter Valid Phone No');
            return false;
        }
        if ((vroMobile.substring(0, 1) !== '9') && (vroMobile.substring(0, 1) !== '8') && (vroMobile.substring(0, 1) !== '7') && (vroMobile.substring(0, 1) !== '6')) {
            alert('Invalid Phone No ');
            return false;
        }
        setMessage('');
        try {
            const dto = { src_no: srcNo, fps_id: fpsId, vro_name: vroName, vro_uid: vroUid, vro_mobile: vroMobile, nom_status: nomStatus };
            const response = await axios.post(`${process.env.REACT_APP_URL}/api/nominee/update`, dto);
            const newDetails = await fetchDetails(srcNo);
            setConfirmation({
                message: response.data,
                details: newDetails
            });
            setDetails(null);
            setMessage('');
        } catch (error) {
            console.error(error);
            if (error.response && error.response.status === 500) {
                setMessage('Internal Exception');
            } else {
                setMessage('An error occurred while updating the nominee. Please try again.');
            }
        }
    };

    const cardsDelete = async () => {
        setMessage('');
        try {
            const response = await axios.post(`${process.env.REACT_APP_URL}/api/nominee/delete`, null, { params: { src_no: srcNo } });
            setMessage(response.data);
        } catch (error) {
            console.error(error);
            if (error.response && error.response.status === 500) {
                setMessage('Internal Exception');
            } else {
                setMessage('An error occurred while deleting the nominee. Please try again.');
            }
        }
    };

    const validateName = (value) => {
        const regexp1 = /[^a-zA-Z .]/;
        if (regexp1.test(value)) {
            alert('Only alphabets & Space are allowed');
            return false;
        }
        return true;
    };

    const checkUid = (value) => {
        const numericRegex = /^[0-9]*$/;
        if (!numericRegex.test(value)) {
            setUidError('Only numbers are allowed');
            return false;
        }

        if (value.length < 12) {
            setUidError('Value must be 12 Digits');
            return false;
        } else {
            setUidError('');
            return true;
        }
    };

    const NumericsOnly = (event) => {
        if ((event.which != 8 && event.which != 0 && (event.which < 48 || event.which > 57))) {
            event.preventDefault();
        }
    };

    const handleUidChange = (e) => {
        const value = e.target.value;
        const numericRegex = /^[0-9]*$/;

        if (numericRegex.test(value)) {
            setVroUid(value);
            checkUid(value);
        } else {
            setUidError('Only numbers are allowed');
        }
    };

    const handleMobileChange = (e) => {
        const value = e.target.value;
        const numericRegex = /^[0-9]*$/;

        if (numericRegex.test(value) && value.length <= 10) {
            setVroMobile(value);
        }
    };

    const resetToInitial = () => {
        setConfirmation(null);
        setDetails(null);
        setSrcno('');
        setMessage('');
    };

    return (
        <div className="wrapper row3">
            {!confirmation && (
                <div id="container">
                    <span style={{ color: 'red', fontSize: '14px', fontWeight: 'bold' }}><u>Note :</u></span>{' '}
                    <span style={{ fontSize: '14px', color: 'green' }}>1. Nominee must be belongs to same(Card Holder's) Shop.</span><br />
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <span style={{ fontSize: '14px', color: 'green' }}>2. 1 and 2 Members Failure Cards.</span><br />
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <span style={{ fontSize: '14px', color: 'green' }}>3. Leprosy & Bedridden Cards (Approved By Admin).</span>
                </div>
            )}
            {!confirmation && (
                <div style={{ textAlign: 'center' }}>
                    <table style={{ width: '35%', margin: '0 auto' }}>
                        <tbody>
                            <tr className="tableheader">
                                <th colSpan="2">Card Nominee Addition</th>
                            </tr>
                            <tr>
                                <td>RC No</td>
                                <td>
                                    <input
                                        type="text"
                                        id="rc_no_input"
                                        value={srcno}
                                        onChange={(e) => setSrcno(e.target.value)}
                                        maxLength="25"
                                        autoFocus
                                        required
                                        style={{ backgroundColor: 'white' }}

                                    />
                                </td>
                            </tr>
                            <tr align="center">
                                <td colSpan="2">
                                    <button
                                        onClick={detailsF}
                                        className="button button2"
                                        style={{ marginRight: '7px' }}
                                    >
                                        Submit
                                    </button>
                                    <button
                                        onClick={() => window.history.back()}
                                        className="button button2"
                                    >
                                        Back
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            )}
            {loading && (
                <div style={{ textAlign: "center", marginTop: "20px" }}>
                    <CircularProgress />
                </div>
            )}
            {(message || details || confirmation) && (
                <div style={{ textAlign: 'center', marginTop: '20px' }}>
                    {confirmation ? (

                        <>
                            <div className="styleVRO" style={{ color: 'green' }}>
                                {confirmation.message}
                            </div>
                            <br />
                            <table
                                style={{
                                    width: '35%',
                                    border: '1px solid black',
                                    margin: '20px auto',
                                }}
                            >
                                <tbody>
                                    {confirmation.details.check2 !== undefined ? (
                                        <>
                                            <tr className="tableheader">
                                                <th colSpan="2">Nominee Details Mapping</th>
                                            </tr>
                                            <tr>
                                                <td>Card No</td>
                                                <td>{confirmation.details.srcno}</td>
                                            </tr>
                                            <tr>
                                                <td>Units</td>
                                                <td>{confirmation.details.check2}</td>
                                            </tr>
                                            <tr>
                                                <td>FPS Id</td>
                                                <td>{confirmation.details.fps_id}</td>
                                            </tr>
                                            <tr>
                                                <td>Nominee Name</td>
                                                <td>{confirmation.details.vro_name}</td>
                                            </tr>
                                            <tr>
                                                <td>Nominee UID</td>
                                                <td>{confirmation.details.vro_uid}</td>
                                            </tr>
                                            <tr>
                                                <td>Nominee Mobile</td>
                                                <td>{confirmation.details.remarks}</td>
                                            </tr>
                                        </>
                                    ) : (
                                        <>
                                            <tr className="tableheader">
                                                <td align="center" colSpan="2">Nominee Details</td>
                                            </tr>
                                            <tr>
                                                <td>RC No</td>
                                                <td>{confirmation.details.srcno}</td>
                                            </tr>
                                            <tr>
                                                <td>Last Updated</td>
                                                <td>{confirmation.details.added_date}</td>
                                            </tr>
                                            <tr>
                                                <td>Nominee Name</td>
                                                <td>{confirmation.details.vro_name}</td>
                                            </tr>
                                            <tr>
                                                <td>Nominee UID</td>
                                                <td>{confirmation.details.vro_uid}</td>
                                            </tr>
                                            <tr>
                                                <td>Nominee Mobile</td>
                                                <td>{confirmation.details.remarks}</td>
                                            </tr>
                                        </>
                                    )}
                                    <tr align="center">
                                        <td colSpan="2">
                                            <button onClick={resetToInitial} className="button button2">Back</button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </>
                    ) : (

                        <>
                            {details && (
                                <>
                                    {['add', 'update', 'view'].includes(details.type) && (
                                        <>
                                            {details.vro_message && (
                                                <div className="styleVRO" dangerouslySetInnerHTML={{ __html: details.vro_message }} />
                                            )}
                                            <br />
                                            <table
                                                style={{
                                                    width: '35%',
                                                    border: '1px solid black',
                                                    margin: '20px auto',
                                                }}
                                            >
                                                <tbody>
                                                    {details.type === 'update' && (
                                                        <>
                                                            <tr className="tableheader"><td align="center" colSpan="2">Nominee Details</td></tr>
                                                            <tr>
                                                                <td>RC No</td>
                                                                <td>{details.srcno}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Last Updated</td>
                                                                <td>{details.added_date}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Nominee Name</td>
                                                                <td>
                                                                    <input
                                                                        type="text"
                                                                        value={vroName}
                                                                        required name="vro_name"
                                                                        style={{ backgroundColor: 'white' }}
                                                                        onChange={(e) => {
                                                                            validateName(e.target.value) &&
                                                                                setVroName(e.target.value);
                                                                        }}
                                                                        maxLength="50"
                                                                    />
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>Nominee UID</td>
                                                                <td>
                                                                    <input
                                                                        type="text"
                                                                        value={vroUid}
                                                                        required name="vro_uid"
                                                                        onChange={handleUidChange}
                                                                        onKeyPress={NumericsOnly}
                                                                        maxLength="12"
                                                                        minLength="12"
                                                                        style={{ backgroundColor: 'white' }}
                                                                    />
                                                                    {uidError && (
                                                                        <div style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>
                                                                            {uidError}
                                                                        </div>
                                                                    )}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>Nominee Mobile</td>
                                                                <td>
                                                                    <input
                                                                        type="text"
                                                                        value={vroMobile}
                                                                        required name="remarks"
                                                                        onChange={handleMobileChange}
                                                                        onKeyPress={NumericsOnly}
                                                                        maxLength="10"
                                                                        minLength="10"
                                                                        style={{ backgroundColor: 'white' }}
                                                                    />
                                                                </td>
                                                            </tr>
                                                            <tr align="center">
                                                                <td colSpan="2">
                                                                    <button onClick={cardsUpdate} className="button button2" style={{ marginRight: "7px" }}>Update</button>
                                                                    <button onClick={cardsDelete} className="button button2" style={{ marginRight: "7px" }}>Delete</button>
                                                                    <button onClick={() => window.history.back()} className="button button2">Back</button>
                                                                </td>
                                                            </tr>
                                                        </>
                                                    )}
                                                    {details.type === 'view' && (
                                                        <>
                                                            <tr className="tableheader"><td align="center" colSpan="2">Nominee Details</td></tr>
                                                            <tr>
                                                                <td>Nominee Name</td>
                                                                <td>{details.vro_name}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>FPS</td>
                                                                <td>{details.fps_id}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Mobile</td>
                                                                <td>{details.remarks}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Added From Last</td>
                                                                <td>{details.age} Days</td>
                                                            </tr>
                                                        </>
                                                    )}
                                                    {details.type === 'add' && (
                                                        <>
                                                            <tr className="tableheader"><th colSpan="2">Nominee Details Mapping</th></tr>
                                                            <tr>
                                                                <td>Card No</td>
                                                                <td>{details.srcno}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Units</td>
                                                                <td>{details.check2}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>FPS Id</td>
                                                                <td>{details.fps_id}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Nominee Name</td>
                                                                <td>
                                                                    <input
                                                                        type="text"
                                                                        value={vroName}
                                                                        onChange={(e) => {
                                                                            validateName(e.target.value) &&
                                                                                setVroName(e.target.value);
                                                                        }}
                                                                        maxLength="50"
                                                                        style={{ backgroundColor: 'white' }}
                                                                    />
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>Nominee UID</td>
                                                                <td>
                                                                    <input
                                                                        type="text"
                                                                        value={vroUid}
                                                                        onChange={handleUidChange}
                                                                        onKeyPress={NumericsOnly}
                                                                        maxLength="12"
                                                                        minLength="12"
                                                                        style={{ backgroundColor: 'white' }}
                                                                    />
                                                                    {uidError && (
                                                                        <div style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>
                                                                            {uidError}
                                                                        </div>
                                                                    )}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>Nominee Mobile</td>
                                                                <td>
                                                                    <input
                                                                        type="text"
                                                                        value={vroMobile}
                                                                        onChange={handleMobileChange}
                                                                        onKeyPress={NumericsOnly}
                                                                        maxLength="10"
                                                                        minLength="10"
                                                                        style={{ backgroundColor: 'white' }}
                                                                    />
                                                                </td>
                                                            </tr>
                                                            <tr align="center">
                                                                <td colSpan="2">
                                                                    <button onClick={cardsAdd} className="button button2">Submit</button>
                                                                </td>
                                                            </tr>
                                                        </>
                                                    )}
                                                </tbody>
                                            </table>
                                        </>
                                    )}
                                    {message && (
                                        <font style={{ fontSize: '14px', color: 'red' }}>{message}</font>
                                    )}
                                    {details.type === 'error' && (
                                        <div className="styleVRO" dangerouslySetInnerHTML={{ __html: details.vro_message }} />
                                    )}
                                </>
                            )}
                        </>
                    )}
                </div>
            )}
        </div>
    );
};

export default Card_Nominee_Int;